import { useState } from 'react';
import { useChangeEffect } from './useChangeEffect.js';

function useTransitionState(isIn, transitionDurationMs) {
  const [state, setState] = useState(isIn ? "entered" : "exited");
  useChangeEffect(() => {
    let timeoutId;
    if (isIn) {
      setState("enter-active");
      timeoutId = window.setTimeout(() => {
        setState("entered");
      }, transitionDurationMs);
    } else {
      setState("exit-active");
      timeoutId = window.setTimeout(() => {
        setState("exited");
      }, transitionDurationMs);
    }
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isIn]);
  return state;
}

export { useTransitionState };
//# sourceMappingURL=transition-state.js.map
